import React, { Component } from "react";
import { Col, Container, Form, FormGroup, Row, Button, Input, Label } from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import { AuthContext } from '../auth';

import Feature4 from '../assets/images/features/img-4.png';
import LogoDark from '../assets/images/logo-dark.png';
import AIS_logo from '../assets/images/AiS_Logo (1).svg'
class Login extends Component {
  static contextType = AuthContext;
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: null, 
      showPassword: false,
    };
  }

  handleLogin = (e) => {
    e.preventDefault();
    this.setState({ loading: true, error: null }); 

    const username = e.target.username.value;
    const password = e.target.userpassword.value;

    setTimeout(() => {
      const users = [
        { username: "1", password: "1" },
        { username: "demo@appinsnap.com", password: "demo@786"}
      ];

      const foundUser = users.find(
        (user) => user.username === username && user.password === password
      );      if (foundUser) {
        this.context.login('demo-token'); 
        this.props.history.push('/search');
      } else {
        this.setState({ error: "Invalid username or password", loading: false });
      }
    }, 1000);
  };

  togglePasswordVisibility = () => {
    this.setState(prevState => ({
      showPassword: !prevState.showPassword
    }));
  };

  render() {
    const { loading, error, showPassword } = this.state;
    return (
      <React.Fragment>
        <div className="account-home-btn d-none d-sm-block">
          <Link to="/" className="text-primary"><i className="mdi mdi-home h1"></i></Link>
        </div>
        <section className="bg-account-pages py-5">
          <div className="display-table">
            <div className="display-table-cell">
              <Container>
                <Row>
                  <Col lg={12}>
                    <div className="login-box" style={{ maxWidth: '400px', margin: '0 auto', padding: '20px', boxShadow: '0 0 10px rgba(0,0,0,0.1)' }}>
                      <Row className="justify-content-center">
                        <Col lg={12} className="text-left" style={{ maxWidth: '360px' }}>
                          <div className="home-img login-img mb-0">
                            <div className="animation-2"></div>
                            <div className="animation-3"></div>
                            <img src={AIS_logo} className="img-fluid" alt="" />
                          </div>
                          <div className="p-0 custom-form">
                            <Form onSubmit={this.handleLogin}>
                          <p className="text-muted mb-2 text-center">Sign in to continue to PEP Search Engine.</p>
                              {error && <p className="text-danger text-center">{error}</p>}
                              <FormGroup>
                                <Label for="username">Username</Label>
                                <Input type="text" name="username" id="username" placeholder="Enter username" required disabled={loading} />
                              </FormGroup>                              <FormGroup>
                                <Label for="userpassword">Password</Label>
                                <div style={{ position: 'relative' }}>
                                  <Input 
                                    type={showPassword ? "text" : "password"} 
                                    name="userpassword" 
                                    id="userpassword" 
                                    placeholder="Enter password" 
                                    required 
                                    disabled={loading} 
                                  />
                                  <i 
                                    className={`mdi ${showPassword ? 'mdi-eye-off' : 'mdi-eye'}`}
                                    onClick={this.togglePasswordVisibility}
                                    style={{
                                      position: 'absolute',
                                      right: '12px',
                                      top: '50%',
                                      transform: 'translateY(-50%)',
                                      cursor: 'pointer',
                                      color: '#6c757d'
                                    }}
                                  />
                                </div>
                              </FormGroup>
                              <div className="mt-3">
                                <Button color="primary" block type="submit" disabled={loading}>
                                  {loading ? "Loading..." : "Log In"}
                                </Button>
                              </div>
                            </Form>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default withRouter(Login);
